export default __webpack_public_path__ + "static/media/logo.bcc922d6.svg";